import { HealthUser } from "@app/core/models/health-user.state";
import { createAction, props } from "@ngrx/store";

export const search = createAction("[User Search/API] Search", props<{ searchTerm: string }>());
export const searchSuccess = createAction(
  "[User Search/API] Search Success",
  props<{ users: HealthUser[] }>()
);
export const searchFailure = createAction("[User Search/API] Search Failure");
